module.exports = __webpack_public_path__ + "img/menu.c58b2e2c.png";